// extracted by mini-css-extract-plugin
export default {"btnContainer":"btnContainer___TjKGw"};